"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import BiharFooter from "./BiharFooter";

export default function BiharLayoutContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const hideHeaderFooter =
    pathname.startsWith("/bihar/school-maps") ||
    pathname.startsWith("/bihar/magic-match") ||
    pathname.startsWith("/bihar/mutual-transfer");
  // Pricing is a focused checkout screen — it keeps the footer (policy links) but
  // drops the site bar so the pass fills the viewport.
  const hideHeader = hideHeaderFooter || pathname.startsWith("/bihar/pricing");

  return (
    <div className="min-h-screen bg-white">
      {/* Header: hidden on /bihar/school-maps and /bihar/magic-match */}
      {!hideHeader && (
        <header className="bg-white shadow-sm border-b border-zinc-200/50 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-between h-16">
              <Link
                href="/bihar/mutual-transfer"
                className="text-2xl font-bold bg-gradient-to-r from-zinc-600 to-zinc-800 bg-clip-text text-transparent"
              >
                Bihar
              </Link>

              <nav className="hidden md:flex space-x-8">
                <Link
                  href="/bihar/mutual-transfer"
                  className="text-zinc-600 hover:text-zinc-900 transition-colors"
                >
                  Home
                </Link>
              </nav>
            </div>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main>{children}</main>

      {/* Footer */}
      {!hideHeaderFooter && <BiharFooter />}
    </div>
  );
} 